/** What the constants were, so nothing moves until somebody moves it. */
export const DEFAULT_RULE_LIMITS = Object.freeze({
    dailyBudget: 20,
    heavyDayMinutes: 360,
    backToBackMinutes: 15,
    usableGapMinutes: 5,
    idleMinutes: 50,
    sleepTargetHours: 7.5,
    middayStepFloor: 1000,
    stepCeiling: 12000,
});
// The hold Heartbeat books before a run of meetings, in minutes.
export const PROTECT_HOLD_MINUTES = 15;
//# sourceMappingURL=limits.js.map